export const da = {
  "common": {
    "brand": "Fyrrehaven 61",
    "bookNow": "Book via Airbnb",
    "sleepsX": "Plads til {{count}} personer",
    "form": {
      "selectPlaceholder": "Vælg",
      "chooseFile": "Vælg fil",
      "chooseFiles": "Vælg filer",
      "required": "Dette felt er påkrævet",
      "emailMismatch": "E-mail og bekræft e-mail skal være ens.",
      "fileAlreadyAdded": "Dette billede er allerede tilføjet. Fjern det først, hvis du vil vælge et andet billede.",
      "maxFilesReached": "Du kan uploade op til {{count}} målerbilleder.",
      "moreFileIssues": "{{count}} problem mere kræver opmærksomhed."
    }
  },
  "home": {
    "heroTitle": "Familievenligt sommerhus i skoven – tæt på stranden",
    "heroSubtitle": "Pool, vildmarksbad, sauna, aktivitetsrum og plads til hele familien.",
    "ctaSeeHouse_da": "Se huset",
    "ctaSeeHouse_en": "See the house",
    "badgePool": "Udendørs opvarmet pool",
    "badgeHotTub": "Vildmarksbad",
    "badgeActivityRoom": "Aktivitetsrum",
    "badgeBeach": "Tæt på strand",
    "altKitchen": "Lyst køkken-alrum",
    "altPool": "Udendørs opvarmet pool",
    "altHotTub": "Vildmarksbad i haven",
    "altBeach": "Stranden ved Fjellerup",
    "whyFamiliesTitle": "Hvorfor familier elsker Fyrrehaven 61",
    "whyFamiliesSub": "Alt hvad I har brug for til en hyggelig ferie – med naturen lige udenfor.",
    "featSleeps": "Plads til {{count}} personer (sengefordeling og børneudstyr)",
    "featPool": "Udendørs opvarmet pool i sæsonen",
    "featHotTub": "Afslapning i vildmarksbadet under trætoppene",
    "featActivityRoom": "Aktivitetsrum med billard, bordtennis, airhockey, dart og projektor",
    "featBeach": "Kort gåtur til strand og iskiosk",
    "featForest": "Skovområde med legepladser og stier",
    "featKids": "Højstol, weekendseng og familiespil",
    "featWifi": "Hurtigt Wi-Fi til streaming og arbejde",
    "featParking": "Gratis parkering ved huset",
    "reviewsTitle": "Gæsteanmeldelser",
    "reviewsSub": "Vi linker til Airbnb for alle anmeldelser.",
    "quote1": "Perfekt til børnefamilier – poolen var et hit!",
    "quote2": "Roligt område, tæt på strand og skov.",
    "quote3": "Rent, lyst og nemt at booke.",
    "seeMoreOnAirbnb": "Se flere på Airbnb",
    "mapTitle": "Fyrrehaven 61 på kortet",
    "readyTitle": "Klar til at booke?",
    "readySub": "Tjek ledige datoer og priser på Airbnb."
  },
  "reviews": {
    "ariaLabel": "Anmeldelser",
    "title": "Gæsterne siger",
    "ratingLabel": "{{value}} ud af 5",
    "scrollLeft": "Scroll venstre",
    "scrollRight": "Scroll højre",
    "readMore": "Læs hele anmeldelsen",
    "showLess": "Vis mindre",
    "emptyReview": "Denne gæst gav en stjernebedømmelse uden skriftlig kommentar.",
    "source": "Kilde",
    "airbnbCta": "Se alle anmeldelser på Airbnb"
  },
  "book": {
    "hero": {
      "title": "Booking",
      "subtitle": "Forespørg direkte hos os – eller book via Airbnb, hvis du foretrækker det.",
      "badges": {
        "pool": "Opvarmet udendørs pool (1/5–1/10)",
        "guests": "Plads til 10 gæster",
        "family": "Familievenligt"
      },
      "airbnbCta": "Booking Airbnb",
      "imageAlt": "Booking af feriehus ved Fjellerup"
    },
    "intro": {
      "title": "Hvordan vil du booke?",
      "body": "Du kan enten sende os en direkte forespørgsel via formularen nedenfor, eller du kan booke via Airbnb, hvis du foretrækker det. Vi svarer normalt inden for 1 time.",
      "noteTitle": "Praktisk",
      "notePool": "Udendørs pool er opvarmet ca. 29 °C og åben 1. maj – 1. oktober. Maks. 10 personer. Ingen fester.",
      "noteUtilities": "El: 4 kr./kWh, vand: 80 kr./m³ (afregnes efter opholdet)."
    },
    "process": {
      "title": "Sådan foregår en booking",
      "lead": "Det er en forespørgsel – ikke en øjeblikkelig reservation. Vi vender hurtigt tilbage med enten lejekontrakt eller et venligt afslag.",
      "aria": "Bookingproces",
      "steps": {
        "request": {
          "title": "Send forespørgsel",
          "body": "Vælg ønskede datoer i kalenderen og udfyld formularen nedenfor."
        },
        "review": {
          "title": "Vi gennemgår din forespørgsel",
          "bodyIntro": "Vi tjekker tilgængelighed, antal gæster og formål med opholdet.",
          "bodyRules": "Husregler: ingen fester og ingen rene ungdomsgrupper under {{minAge}} år. Max {{maxGuests}} personer."
        },
        "reply": {
          "title": "Svar fra os (typisk inden for {{responseHours}} timer)",
          "bodyIntro": "Du modtager svar fra os (typisk inden for {{responseHours}} timer).",
          "bodyDetails": "Er alt i orden, sender vi en lejekontrakt med pris og praktisk info. Passer datoerne ikke – eller bryder forespørgslen husreglerne – foreslår vi alternativer eller afviser venligt."
        },
        "confirm": {
          "title": "Du underskriver – vi bekræfter",
          "bodyIntro": "Bookingen er først endeligt bekræftet, når lejekontrakten er underskrevet og de aftalte betalinger er modtaget.",
          "bodyDetails": "Herefter får du velkomstmail med nøgleinfo, adresse og ankomstvejledning."
        }
      },
      "note": {
        "label": "Husregler kort:",
        "text": "ingen fester, ingen rene ungdomsgrupper under {{minAge}} år, og vis hensyn til naboerne. Max {{maxGuests}} gæster.",
        "readMore": "Læs mere her:",
        "fees": "gebyroversigt",
        "privacy": "privatlivspolitik"
      }
    }
  },
  "area": {
    "attractions": {
      "djurs-sommerland": {
        "title": "Djurs Sommerland",
        "description": "Nordens største sommerland med 60+ forlystelser og vandland."
      },
      "legerevet-grenaa": {
        "title": "Lege-revet (Grenaa) – legeland",
        "description": "Indendørs legeland: klatrebaner, rutsjebaner og boldbassin."
      },
      "hermans-hule-grenaa": {
        "title": "Hermans Hule (Grenaa) – legeland",
        "description": "Stort indendørs legeland med rutsjebaner og trampoliner."
      },
      "fjollehaven": {
        "title": "Fjollehaven",
        "description": "Udendørs legeplads"
      },
      "fjellerup-strand": {
        "title": "Fjellerup Strand",
        "description": "Bred, børnevenlig sandstrand i cykelafstand."
      },
      "mols-bjerge": {
        "title": "Mols Bjerge Nationalpark",
        "description": "Kuperet landskab, flotte udsigter og gode vandreruter."
      },
      "kalo-slotsruin": {
        "title": "Kalø Slotsruin",
        "description": "Ikonisk borgruin i Kalø Vig – tur ad den gamle stenvej."
      },
      "kattegatcentret": {
        "title": "Kattegatcentret (Grenaa)",
        "description": "Akvarium med hajer og sæler – perfekt til blæsende/kolde dage."
      },
      "randers-regnskov": {
        "title": "Randers Regnskov",
        "description": "Tropiske kupler med dyr og planter – året rundt."
      },
      "vaffelbageri": {
        "title": "Fjellerup Vaffelbageri",
        "description": "Berømte vafler ved stranden – sæsonåbent."
      },
      "vaffelbageri-food": {
        "title": "Vaffelbageri - fastfood",
        "description": "Is og Fastfood – sæsonåbent."
      },
      "vaffelhuset": {
        "title": "Vaffelhuset",
        "description": "Hjemmelavet is – sæsonåbent."
      },
      "brugsen-fjellerup": {
        "title": "Brugsen Fjellerup Strand",
        "description": "Lokal dagligvarebutik til alt det praktiske."
      },
      "alt-til-dagen": {
        "title": "Alt Til Dagen",
        "description": "Lokal dagligvarebutik til alt det praktiske."
      }
    }
  },
  "contact": {
    "hero": {
      "title": "Kontakt os",
      "subtitle": "Vi svarer normalt hurtigt – ofte inden for få timer.",
      "badges": {
        "family": "Familievenligt",
        "beach": "Tæt på strand"
      },
      "imageAlt": "Familien bag huset",
      "primaryCta": "Book direkte",
      "secondaryCta": "Booking Airbnb"
    },
    "form": {
      "heading": "Skriv til os",
      "submit": {
        "message": "Send besked",
        "booking": "Send forespørgsel",
        "sendingMessage": "Sender besked...",
        "sendingBooking": "Sender forespørgsel...",
        "aria": "Send formularen"
      },
      "success": {
        "messageTitle": "Tak for din henvendelse!",
        "bookingTitle": "Tak for din bookingforespørgsel!",
        "messageLead": "Vi vender tilbage hurtigst muligt. Her er en kopi af det, du sendte:",
        "bookingLead": "Vi vender tilbage hurtigst muligt. Her er en oversigt over din forespørgsel:"
      }
    }
  },
  "fees": {
    "page": {
      "title": "Gebyrer",
      "lead": "For at sikre den bedste oplevelse for alle gæster har vi samlet en oversigt over gebyrer, der kan blive relevante i særlige situationer.",
      "infoTitle": "Vigtig information for booking af sommerhuset",
      "badges": {
        "noParties": "Ingen udlejning til fester eller grupper under 25 år.",
        "noPets": "Ingen kæledyr tilladt indendørs.",
        "pool": "Udendørspoolen åben 1. maj – 1. oktober."
      },
      "consumptionTitle": "Forbrug afregnes efter opholdet",
      "consumptionElectricity": "El- og vandforbrug ift. lejekontrakten.",
      "consumptionExtras": "Er der bestilt ekstra service efter booking, vil dette bliver opkrævet.",
      "listTitle": "Gebyrliste",
      "footer": "Bemærk: Gebyrer kan opkræves, hvis vilkår ikke overholdes. Kontakt os ved spørgsmål."
    },
    "items": {
      "early-checkin-unauthorized": {
        "title": "Tidlig indtjekning uden aftale",
        "unit": "pr. påbegyndt halve time"
      },
      "late-checkout-unauthorized": {
        "title": "Sen udtjekning uden aftale",
        "unit": "pr. påbegyndt halve time"
      },
      "hottub-over-42c": {
        "title": "Temperatur overstiger 42 grader",
        "note": "gælder kun vildmarksbadet"
      },
      "hottub-damage": {
        "title": "Skader på vildmarksbad",
        "note": "Minimumsgebyr – faktiske reparations-/udskiftningsomkostninger kan tillægges."
      },
      "spa-tech-damage": {
        "title": "Skader på hot tub-teknik (varmepumpe, vandpumpe m.m.)",
        "note": "Minimumsgebyr – faktiske reparations-/udskiftningsomkostninger kan tillægges."
      },
      "grill-not-cleaned": {
        "title": "Manglende rengøring af grill"
      },
      "trash-not-disposed": {
        "title": "Manglende bortskaffelse af affald",
        "note": "gælder ved udtjekning"
      },
      "dishwasher-not-emptied": {
        "title": "Opvaskemaskine ikke tømt",
        "note": "gælder ved udtjekning"
      },
      "outdoor-furniture-not-returned": {
        "title": "Udendørs møbler ikke sat på plads"
      },
      "loft-toys-not-tidied": {
        "title": "Hems og legetøj ikke ryddet op"
      },
      "doors-windows-not-locked": {
        "title": "Døre eller vinduer ikke låst/lukket"
      },
      "noise-complaints": {
        "title": "Støjgener eller klager fra naboer"
      },
      "remotes-missing": {
        "title": "Manglende fjernbetjeninger",
        "unit": "pr. stk."
      },
      "keys-missing": {
        "title": "Manglende nøgler til hus eller pooltag",
        "unit": "pr. nøgle"
      },
      "mattress-soiling": {
        "title": "Urin/væsker på senge og madrasser",
        "unit": "pr. madras"
      },
      "indoor-smoking": {
        "title": "Rygning indendørs (ikke tilladt)"
      },
      "sauna-damage": {
        "title": "Skader på sauna (inventar/beklædning)",
        "note": "Minimumsgebyr – faktiske reparations-/udskiftningsomkostninger kan tillægges."
      },
      "sauna-stove-damage": {
        "title": "Skader på saunaovn",
        "note": "Minimumsgebyr – faktiske omkostninger kan tillægges."
      },
      "pool-tech-damage": {
        "title": "Skader på poolteknik (pumpe, filter, varmepumpe m.m.)",
        "note": "Minimumsgebyr – faktiske omkostninger kan tillægges."
      },
      "activity-table-damage": {
        "title": "Skader på 3-i-1 multibord",
        "note": "Minimumsgebyr – faktiske reparations-/udskiftningsomkostninger kan tillægges."
      },
      "dart-damage": {
        "title": "Skader på dartskive eller sikkerhedspuder",
        "note": "Minimumsgebyr – faktiske reparations-/udskiftningsomkostninger kan tillægges."
      }
    }
  },
  "extraServices": {
    "page": {
      "eyebrow": "Tilkøb til opholdet",
      "title": "Ekstra services",
      "lead": "Vi vil gerne gøre dit kommende ophold så nemt og behageligt som muligt. Derfor tilbyder vi ekstra services, som du kan anmode om her.",
      "listAria": "Liste over ekstra services",
      "includedTitle": "Inkluderet i lejen",
      "includedText": "Viskestykke - Karklud - Shampoo - Shower gel - Håndsæbe - Opvaskemiddel - Opvaskepulver - Kaffebønner"
    },
    "form": {
      "yes": "Ja",
      "no": "Nej",
      "select": "Vælg",
      "free": "GRATIS",
      "total": "Estimeret ekstra total",
      "submit": "Send forespørgsel",
      "sending": "Sender forespørgsel...",
      "success": "Tak. Din forespørgsel om ekstra services er sendt.",
      "successFollowup": "Vi sørger for det og kontakter dig kun, hvis noget ikke kan lade sig gøre.",
      "summaryYes": "Gæsten ønsker ekstra services.",
      "summaryNo": "Gæsten ønsker ikke ekstra services på nuværende tidspunkt.",
      "noSpecificItems": "Der er ikke valgt specifikke antal.",
      "dateHint": "Ekstra services bestilles normalt senest 3 dage før ankomst, så vi kan nå at klargøre.",
      "lateNotice": "Sene forespørgsler og last minute-bookinger accepteres. Vi sørger for det og kontakter dig kun, hvis noget ikke kan lade sig gøre.",
      "bundleHint": "Komplet pakke med sengetøj, sengelinned og håndklæder",
      "fields": {
        "name": "Booker",
        "email": "E-mailadresse",
        "confirmEmail": "Bekræft e-mail",
        "stayDate": "Dato for ophold",
        "wantsExtras": "Ønsker du ekstra services?",
        "otherRequests": "Andre ønsker?"
      },
      "placeholders": {
        "name": "Navn på personen der har booket opholdet",
        "email": "navn@email.dk",
        "amount": "Ønsket antal",
        "otherRequests": "Skriv dine ønsker her, så finder vi en løsning"
      },
      "hints": {
        "high-chair": "Én højstol tilgængelig",
        "baby-cot": "Én babyseng tilgængelig"
      },
      "calendar": {
        "previous": "Forrige måned",
        "next": "Næste måned"
      },
      "acceptBefore": "Ved at sætte flueben bekræfter du, at du har taget stilling til ekstra services, giver samtykke til behandling af din forespørgsel og har læst og accepteret vores",
      "houseRules": "husregler",
      "and": "og",
      "feeList": "gebyroversigt",
      "acceptAfter": "ved eventuelle overtrædelser. Koden til nøgleboksen sendes 1 time før ankomst, når dette er bekræftet.",
      "errors": {
        "required": "Udfyld venligst navn, e-mail, bekræft e-mail og dato for ophold.",
        "dateTooSoon": "Vælg venligst i dag eller en fremtidig ankomstdato.",
        "email": "Indtast venligst en gyldig e-mailadresse.",
        "emailMismatch": "E-mail og bekræft e-mail skal være ens.",
        "dateNotBooked": "Vi kan ikke finde en booking, der starter på den dato. Vælg venligst bookingens startdato.",
        "nameMismatch": "Navnet matcher ikke den booking, vi fandt på den dato. Brug venligst samme navn som på bookingen.",
        "bookingCheckUnavailable": "Vi kunne ikke tjekke bookingkalenderen lige nu. Prøv venligst igen om lidt.",
        "bookingCheck": "Vi kunne ikke bekræfte dine bookingoplysninger. Tjek navn og dato, og prøv igen.",
        "noSelection": "Vælg venligst mindst én ekstra service.",
        "tooManyPeople": "Sengetøj, sengelinned, håndklæder og pakker kan samlet højst bestilles til 10 personer.",
        "accept": "Accepter venligst husregler og gebyroversigt før indsendelse.",
        "rateLimited": "Der er sendt for mange forespørgsler på kort tid. Vent venligst et øjeblik, og prøv igen.",
        "tooFast": "Gennemgå venligst formularen én gang mere, og send den igen om et øjeblik.",
        "formExpired": "Formularsessionen er udløbet. Genindlæs siden, og send forespørgslen igen.",
        "security": "Forespørgslen kunne ikke accepteres fra denne browsersession. Genindlæs siden, og prøv igen.",
        "lateSubmit": "Din sene forespørgsel kunne ikke sendes automatisk. Da opholdet er tæt på, bedes du kontakte os direkte, så vi kan arrangere det.",
        "network": "Forbindelsen blev afbrudt, før forespørgslen kunne sendes. Tjek din internetforbindelse, og prøv igen.",
        "lateNetwork": "Forbindelsen blev afbrudt, før din sene forespørgsel kunne sendes. Da opholdet er tæt på, bedes du kontakte os direkte, hvis den ikke går igennem.",
        "submit": "Kunne ikke sende forespørgslen. Prøv igen om lidt."
      }
    }
  },
  "guest": {
    "accordion": {
      "pool": {
        "duckkey": "Pool tag nøgle",
        "keyhole": "Nøglehul til pooltag"
      },
      "spa": {
        "rules": {
          "title": "Regler og brug",
          "note": "Bemærk!",
          "intro": "I skal ikke selv have brænde med til vildmarksbad med da det varmes elektrisk. Karret er rent og klar ved ankomst.",
          "maxTemp": "Maks temperatur 40°C.",
          "buttons": "På siden af vildmarksbadet er der to knapper",
          "button1": "Knap 1 — Lys",
          "button2": "Knap 2 — Massage/bobler",
          "dial": "Skru op og ned for styrken",
          "waterLevel": "Vand niveau må ikke overstige de øverste massage dyser",
          "massageTemp": "Massage funktionen må ikke tændes før vandet er +20°",
          "firewood": "Vildmarksbadet er elektrisk opvarmet; brug ikke brænde.",
          "chlorine": "Der gøres brug af klor tabs for at holde vandet rent",
          "drain": "Gæster skal ikke tømme vildmarksbadet efter opholdet.",
          "imageAlt": "Vildmarksbad",
          "caption": "Alt brug af vildmarksbad er på eget ansvar."
        },
        "fire": {
          "title": "Optænding af vildmarksbad",
          "fill": "Hæld vand i karret med vandslangen, det vil tage ca. 2 timer.",
          "heater": "Når vandet er 10 cm over det øverste hul i ovnen, kan man tænde op og smide 2 klor tabs i.",
          "smoke": "Lav optændingen med tørt brænde og sørg for at få en god flamme i ovnen for at undgå “doven” røg op ad skorstenen.",
          "wood": "Fyld gerne ca. 2/3 af ovnen med brænde",
          "cover": "Placér termocover på toppen og hav tålmodighed",
          "stopWood": "Når temperaturen på badevandet er ca. 36°, fyldes der ikke mere brænde på.",
          "temp": "Tjek badevandstermometer inden badet benyttes. Ideelt imellem 36°–40°",
          "close": "Efter brug lukkes termocover og når man er færdig bedes man tømme vandet"
        }
      },
      "sauna": {
        "rules": {
          "title": "Regler og brug",
          "lightTitle": "Tænd lyset",
          "light": "Udenfor saunaen er der en kontakt til både indendørs og udendørs lys.",
          "heaterTitle": "Indstil varmeapparatet",
          "heater": "Inde i saunaen finder du to drejeknapper nederst:",
          "leftTitle": "Venstre knap: Temperatur",
          "left": "Indstil ønsket temperatur (70–80°C anbefales).",
          "rightTitle": "Højre knap: Tid",
          "right": "Drej for at starte saunaen. Ved '0' starter den straks. Drejer du forbi '0', aktiveres timer-funktion.",
          "waitTitle": "Vent på opvarmning",
          "wait": "Saunaen er klar efter ca. 30–45 minutter.",
          "showerTitle": "Tag et brusebad før brug",
          "shower": "Vask kroppen og tør dig – det forbedrer hygiejne og varmeoptag.",
          "towelTitle": "Brug et håndklæde",
          "towel": "Sæt dig altid på et håndklæde – også fødderne.",
          "durationTitle": "Saunér i 10–15 minutter ad gangen",
          "duration": "Lyt til kroppen og drik rigeligt med vand.",
          "coolTitle": "Køl ned bagefter",
          "cool": "Tag et bad eller gå udendørs – det styrker velvære."
        },
        "donts": {
          "title": "Hvad du ikke må gøre",
          "waterTitle": "Hæld ikke store mængder vand på ovnen",
          "water": "En lille smule ad gangen er okay. For meget kan skade ovnen eller udløse sikkerhedssystemet.",
          "alcoholTitle": "Ingen alkohol før eller under brug",
          "alcohol": "Alkohol er forbudt – det kan være livsfarligt i varme omgivelser.",
          "foodTitle": "Ingen mad eller drikke",
          "childrenTitle": "Ingen børn uden opsyn",
          "children": "Kun kort brug og altid under opsyn.",
          "oilsTitle": "Ingen olier eller duftsten",
          "oils": "Kan beskadige ovnen og give allergiske reaktioner."
        },
        "safety": {
          "title": "Vigtige sikkerhedsregler",
          "off": "Sluk altid for ovnen efter brug – drej højre knap til '0'.",
          "health": "Brug ikke saunaen hvis du er syg, gravid eller har pacemaker.",
          "storage": "Brug ikke saunaen til opbevaring.",
          "air": "Hold luftindtag ved ovnen fri.",
          "leave": "Forlad saunaen hvis du føler ubehag.",
          "water": "Drik vand før og efter brug for at undgå dehydrering."
        }
      },
      "manual": {
        "during": {
          "wifi": {
            "title": "Wi-Fi",
            "name": "Navn: HabibiHytten",
            "password": "Kode: Dolma3000",
            "speed": "Hastighed: optil 1000/1000 Mbit",
            "coverage": "Dækning i hele huset også udenfor"
          },
          "espresso": {
            "title": "Espressomaskine",
            "beans": "Kaffebønner inkl.",
            "clean": "Efter hver kaffe kop, trykkes der på start for at rense.",
            "empty": "Skal tømmes for spildevand og kaffegums jævnligt og fyldes op med rent vand i vandbeholderen"
          },
          "foldingDoor": {
            "title": "Foldedør",
            "body": "Den store foldedør ud til poolen kan åbnes i 5 dele. Åbn det stille og roligt. Går den i stykker er det jeres ansvar."
          },
          "access": {
            "title": "Adgang forbudt",
            "shed": "Skur",
            "annex": "Anneks",
            "activityRoomTechnical": "Låst teknikområde i aktivitetsrummet"
          },
          "smoking": {
            "title": "Rygning",
            "body": "Alt rygning er forbudt indendørs eller i den overdækkede terrasse. Vi henviser til at ryge udenfor."
          },
          "pool": {
            "title": "Pool",
            "body": "Åben i sommerperiode"
          },
          "tv": {
            "title": "Smart TV",
            "streaming": "Download og login på din favorit streaming tjenester",
            "cast": "Cast fra din telefon via Chromecast"
          },
          "washer": {
            "title": "Vaskemaskine og tørretumbler",
            "free": "Kan frit bruges",
            "program": "Indstil til ønskede program og læn dig tilbage",
            "water": "Husk at tømme tørretumbleren for vand"
          },
          "ev": {
            "title": "El bil",
            "body": "I kan frit tilslutte jeres El bil. Bemærk dog at den kan være slukket når I kommer."
          },
          "safety": {
            "title": "Sikkerhed",
            "sensors": "Vinduer og udvendige døre har sensor for at vi kan se om der er åbent.",
            "temp": "Temperatur overvågning, indendørs, udendørs, saune, pool og vildmarksbad",
            "video": "Skur og anneks er videoovervåget"
          }
        },
        "after": {
          "tidying": {
            "title": "Oprydning",
            "house": "Opryd hele huset og have",
            "packed": "Dobbelt tjek I har det hele med"
          },
          "dishwasher": {
            "title": "Opvaskemaskine",
            "body": "Vask alt op og tøm opvaskemaskinen"
          },
          "espresso": {
            "title": "Espressomaskine",
            "waste": "Tøm beholderen med kaffegums",
            "water": "Tøm vandbeholderen",
            "tray": "Tøm drypbakken"
          },
          "trash": {
            "title": "Affald",
            "sort": "Affald samles og smides sorteret i affaldsbeholderne udenfor",
            "bottles": "Tomme vin og spiritus flasker smides ud i affaldskontaineren"
          },
          "lights": {
            "title": "Lys",
            "body": "Sluk alt belysning, også udendørs"
          },
          "outdoor": {
            "title": "Udendørs møbler",
            "body": "Sæt udemøblerne som da I ankom"
          },
          "grill": {
            "title": "Grill",
            "body": "Efterlad grillen rengjort og dækket til"
          },
          "hotTub": {
            "title": "Vildmarksbad",
            "body": "Efterlad vildmarksbadet, som det er efter brug. Vandet må gerne blive i."
          },
          "activityRoom": {
            "title": "Aktivitetsrum",
            "accessories": "Læg alt spiltilbehør tilbage på plads.",
            "tabletop": "Læg bordtennis-/almindelig bordplade på igen først, og læg derefter dugen ovenpå bordet, før I forlader rummet.",
            "chairs": "Fold klapstolene sammen, og efterlad dem som ved ankomst.",
            "fridge": "Tøm køleskabet for jeres egne varer.",
            "power": "Sluk projektor, lys og udstyr, der ikke skal være tændt."
          },
          "lock": {
            "title": "Lås af",
            "windows": "Luk alle vinduer",
            "key": "Lås døren og læg nøgle i nøgleboksen"
          }
        }
      },
      "checkInOut": {
        "el": "Placering af EL-måler",
        "elAlt": "EL-måler placering",
        "elLocation": "Placering: Til højre for hoveddøren. Brug blitz til billedet.",
        "water": "Placering af vandmåler (hus)",
        "waterAlt": "Vandmåler i huset",
        "waterLocation": "Placering: Til højre i teknikskabet. Åbn skydedøren i entréen.",
        "poolWater": "Placering af vandmåler (pool)",
        "poolWaterAlt": "Vandmåler ved pool",
        "poolWaterReadingAlt": "Aflæsning af poolens vandmåler",
        "poolWaterLocation": "Placering: I skuret finder I vandmåleren i venstre hjørne. Vær opmærksom på pooludstyret."
      },
      "practical": {
        "coffee": {
          "title": "Kaffemaskine",
          "body": "Kaffemaskinen skal tømmes for spildevand og kaffegrums jævnligt efter brug og fyldes på med rent vand i vandbeholderen. Kaffebønner er inkluderet – hvis I har brug for flere, er det for egen regning.",
          "manual": "Se manual her"
        },
        "sofa": {
          "title": "Sovesofa",
          "body": "Sådan bruger du sovesofaen – se videoen nedenfor:",
          "fallback": "Din browser understøtter ikke video."
        },
        "security": {
          "title": "Overvågning og alarmer",
          "cameras": "Overvågning ved pool teknik, anneks og skur",
          "shell": "Skalsikring på alle vinduer og døre, inkl. udendørsdøre",
          "smoke": "Røg- og kuliltealarm sender besked til værterne ved udløsning",
          "temp": "Pool, vildmarksbad, sauna og udetemperatur overvåges – kan ses på skærmen ved tv’et"
        },
        "sonos": {
          "title": "Sonos-højtaler",
          "iphone": "iPhone: Brug AirPlay og vælg Sonos i højttalerlisten.",
          "android": "Android: Brug Sonos-appen eller Bluetooth hvis muligt."
        },
        "stove": {
          "title": "Kogeplade fejl",
          "body": "Bemærk: Når komfuret viser “LO” betyder det \"låst\". Hold startknappen nede i 3 sekunder for at låse op."
        },
        "games": {
          "title": "Brætspil & Playstation",
          "cupboard": "Brætspil findes i skabet over køleskabet.",
          "purchases": "I må gerne bruge vores spil eller downloade jeres egne – men vi dækker ikke udgifter til køb."
        }
      }
    },
    "checkInOutPage": {
      "title": "Tjek-ind og ud",
      "desktopTitle": "Tjek-ind og Tjek-ud",
      "description": "Mobilside til aflæsning af el og vandmåler",
      "mobileOnly": "– Denne side er kun tilgænglig via en mobil telefon",
      "unknownError": "Ukendt fejl",
      "fallbackError": "Noget gik galt.",
      "meterLocationPrompt": {
        "eyebrow": "Målerguide",
        "text": "Find målerne, før du indtaster aflæsningerne. Vi anbefaler, at du trykker på upload-knappen og tager hvert billede direkte derfra.",
        "button": "Vis placeringer"
      },
      "fields": {
        "name": {
          "label": "Navn",
          "placeholder": "Lejer navn"
        },
        "keycode": {
          "label": "Nøgleboks kode",
          "placeholder": "Indtast kode"
        },
        "checkType": {
          "label": "Tjek-ind eller Tjek-ud",
          "checkin": "Tjek-ind",
          "checkout": "Tjek-ud"
        },
        "confirmEmail": "Bekræft e-mail",
        "elReading": "EL måler aflæsning",
        "elReadingDescription": "Brug blitz til billedet af elmåleren, så tallene er tydelige.",
        "waterHouse": "Vand (huset)",
        "waterHouseExamplePrefix": "Eksempel:",
        "waterHouseExampleSuffix": ". De hvide tal står før kommaet, og de røde tal står efter kommaet.",
        "waterPool": "Vand (pool)",
        "meterImages": {
          "label": "Billede af aflæsning",
          "description": "Du kan uploade mere end ét billede. Verificer hver aflæsning med tydelige billeder, og brug blitz på elmåleren."
        },
        "comment": {
          "label": "Kommentar",
          "placeholder": "Skriv din kommentar her"
        },
        "consent": "Jeg giver samtykke til, at mine oplysninger må bruges til at behandle min henvendelse."
      },
      "submit": "Send aflæsning",
      "sending": "Uploader billeder og sender aflæsningen. Det kan tage et øjeblik...",
      "success": "Tak! Din aflæsning er sendt.",
      "progress": {
        "compressing": "Klargør billeder",
        "ready": "Billeder klar til upload",
        "readyOriginal": "Billeder klar til upload",
        "originalSize": "Valgt størrelse: {{size}}",
        "uploading": "Uploader aflæsning",
        "uploadSize": "Uploadstørrelse: {{size}}"
      },
      "errors": {
        "rateLimited": "Der er sendt for mange aflæsninger på kort tid. Vent venligst et øjeblik, og prøv igen.",
        "tooFast": "Gennemgå venligst formularen én gang mere, og send den igen om et øjeblik.",
        "formExpired": "Formularsessionen er udløbet. Genindlæs siden, og send aflæsningen igen.",
        "invalidFileType": "Upload venligst kun billedfiler. Fotos fra telefonens kamera accepteres.",
        "fileTooLarge": "Et eller flere billeder er for store. Åbn venligst hvert målerbillede, tag et screenshot, og upload screenshots i stedet.",
        "fileTooLargeInline": "Dette billede er for stort. Tag venligst et screenshot af billedet, og tilføj screenshottet i stedet.",
        "fileStillTooLargeInline": "Dette billede er stadig for stort efter klargøring. Tag venligst et screenshot af billedet, og tilføj screenshottet i stedet.",
        "totalUploadTooLarge": "Billederne er for store. Upload venligst screenshots af målerbillederne i stedet.",
        "tooManyFiles": "Der er uploadet for mange billeder. Upload kun de nødvendige målerfotos.",
        "tooManyFields": "Der blev sendt for meget information. Genindlæs siden, og prøv igen.",
        "missingFiles": "Upload venligst mindst ét billede af måleraflæsningen.",
        "validation": "Tjek venligst de påkrævede felter, og sørg for at måleraflæsningerne er udfyldt korrekt.",
        "mail": "Din aflæsning blev registreret, men mailen kunne ikke sendes automatisk. Vi kan stadig se den i admin-systemet.",
        "network": "Forbindelsen blev afbrudt, før aflæsningen kunne sendes. Tjek din internetforbindelse, og prøv igen.",
        "serverResponse": "Aflæsningen kunne ikke sendes, fordi serveren returnerede en ulæselig fejl. Prøv igen med screenshots af målerbillederne."
      },
      "errorLabel": "Fejl:",
      "errorTitle": "Aflæsningen kunne ikke sendes"
    },
    "manualPage": {
      "title": "Manual 🧭 Fyrrehaven 61",
      "description": "Se vigtig info til dit ophold: el-måler, vandmåler, adgang, regler og mere.",
      "imageAlt": "Manual billede",
      "hero": {
        "title": "Tak for I har valgt vores sommerhus!",
        "subtitle": "Her er lidt info omkring hvordan I behandler huset – I må meget gerne følge os på sociale medier og dele jeres oplevelse med #fyrrehaven61"
      },
      "quickLinks": {
        "pool": "Pool",
        "hotTub": "Vildmarksbad",
        "sauna": "Sauna"
      },
      "notice": {
        "label": "HUSK!",
        "body": "Det er jeres ansvar at få aflæst el og vand måler. Glemmer I dette kan I komme til at betale mere end jeres forbrug.",
        "meterLinkIntro": "Aflæsning skal ske ved tjekind og tjekud via vores hjemmeside. I finder QR-koden ved indgangen eller ",
        "meterLink": "her",
        "electricity": "Aflæs EL tavlen",
        "houseWater": "Aflæs Vand i huset",
        "poolWater": "Aflæs vand til pool i skuret"
      },
      "stayTitle": "Manual til jeres ophold",
      "afterTitle": "Efter endt ophold"
    },
    "poolPage": {
      "seo": {
        "title": "Pool – Maj 2026",
        "description": "Sådan bruger og åbner I poolen ved sommerhuset."
      },
      "title": "POOL",
      "subtitle": "– Maj 2026",
      "warning": {
        "title": "For at spare strøm og varme anbefales det at bade med pooltaget lukket på kolde dage",
        "body": "I bedes venligst ikke have hele pool taget åbent i længere tid. Poolen kan tilgås via den indbyggede dør."
      },
      "rules": {
        "title": "Regler og brug",
        "temperature": "Temperaturen i poolen er ca. 28 grader",
        "depth": "1,5 meter dyb",
        "automatic": "Pool bliver automatisk fyldt med vand og kemikalier",
        "noDiving": "Ingen hovedspring",
        "tech": "Alt teknik står i skuret og kan styres via app, I bedes derfor kontakt os ved problemer!"
      },
      "preparation": {
        "title": "Klargøring",
        "unlock": "Brug “ande” nøglen til at låse poolen op (se billeder)",
        "open": "Pool taget kan nu skubbes ud eller døren åbnes",
        "cover": "Fjern pool cover og læg det i skuret (foldes eller rulles sammen)"
      }
    },
    "activityRoomPage": {
      "seo": {
        "title": "Aktivitetsrum – Fyrrehaven 61",
        "description": "Guide til brug af aktivitetsrummet med billard, bordtennis, airhockey, dart, projektor, køleskab og sikkerhedsregler."
      },
      "title": "Aktivitetsrum",
      "subtitle": "Her kan I spille billard, bordtennis, airhockey og dart, eller sætte film på projektoren med Chromecast og Google TV. Klapstole findes i rummet, så I kan lave ekstra siddepladser.",
      "fridge": {
        "title": "Køleskab ved ankomst",
        "body": "Køleskabet skal tændes, når I ankommer. Brug kontakten ved siden af køleskabet, og giv det lidt tid til at blive koldt."
      },
      "table": {
        "title": "Brug af multibordet",
        "intro": "Multibordet bruges til billard, airhockey og bordtennis. Det er tungt, så skift spil langsomt og forsigtigt.",
        "howToTitle": "Sådan skifter I spil",
        "steps": [
          "Fjern altid kugler, køer, bats, pucke og net fra bordet, før I skifter spil.",
          "Bordet har specialhjul med lås. Hvis I flytter bordet, skal alle fire hjul låses igen, før bordet bruges.",
          "Skift mellem billard og airhockey ved at låse bordets beslag op, vende bordpladen roligt og låse beslagene igen, før I spiller.",
          "Til bordtennis lægges bordtennispladerne ovenpå bordet, og nettet sættes fast i midten.",
          "Når bordet bruges som almindeligt bord, skal dugen lægges ovenpå bordet. Spild kan ellers trænge ned og ødelægge spillet under bordpladen.",
          "Brug kun det tilbehør, der hører til spillet, og læg det hele tilbage efter brug."
        ],
        "wheelLockImageAlt": "Nærbillede af låsen på et af multibordets hjul",
        "wheelLockCaption": "Der er lås på alle fire hjul. Lås alle hjul, før I spiller.",
        "bracketsImageAlt": "Nærbillede af de røde bordbeslag på multibordet",
        "bracketsCaption": "Åbn bordbeslagene, før bordpladen vendes, og lås dem igen før brug.",
        "safetyTitle": "Brugs- og sikkerhedsanvisninger",
        "safety": [
          "Bordet må kun bruges, når alle fire låsebeslag er låst og understøtter bordet.",
          "Bordet må kun bruges, når alle fire hjullåse er låst.",
          "Når bordet drejes, skal alle fire låsebeslag være helt åbne. Hvis et beslag er lukket, kan det gå i stykker.",
          "Bordet skal altid drejes langsomt og med størst mulig forsigtighed.",
          "Læn dig aldrig op ad bordet, og sid aldrig på bordets kanter.",
          "Sørg altid for, at poolkuglerne er ude af bordet, og at airhockey-strømkablet er trukket tilbage, før du prøver at dreje bordet.",
          "Børn skal altid være sammen med en voksen, når de spiller på eller drejer bordet.",
          "Kun til indendørs brug."
        ]
      },
      "airHockey": {
        "title": "Airhockey",
        "steps": [
          "Sæt airhockey-strømkablet i en stikkontakt, før I spiller.",
          "Brug kun de tilhørende pucks og håndskydere.",
          "Tag strømkablet ud igen, og træk det tilbage, før bordet drejes til et andet spil."
        ]
      },
      "dart": {
        "title": "Dartskive",
        "steps": [
          "Dartskiven hænger over køleskabet.",
          "Brug kun pilene ved dartskiven.",
          "Der er sikkerhedspuder rundt om dartskiven, hvis en pil rammer ved siden af. Tjek alligevel altid området omkring skiven, før I kaster.",
          "Børn må kun kaste med pile sammen med en voksen."
        ]
      },
      "projector": {
        "title": "Projektor, Chromecast og Google TV",
        "steps": [
          "Tænd projektoren.",
          "Tænd soundbaren manuelt, hvis den er slukket. Den lyser rødt, når den er slukket, og forbinder automatisk bagefter.",
          "Cast fra jeres telefon, eller brug Google TV til at logge ind på jeres egen streamingtjeneste.",
          "Log ud af streamingtjenester, når I er færdige.",
          "Sluk kun projektoren, før I forlader rummet. Soundbaren slukker sammen med projektoren."
        ]
      },
      "closedArea": {
        "title": "Lukket teknikområde",
        "body": "Området med poolmotor, kemikalier og teknisk udstyr er låst og må ikke åbnes. Den lukkede sektion er videoovervåget."
      },
      "leaving": {
        "title": "Når I forlader rummet",
        "steps": [
          "Læg alt spiltilbehør tilbage på plads.",
          "Læg bordtennis-/almindelig bordplade på igen først, og læg derefter dugen ovenpå bordet, før I forlader rummet.",
          "Fold klapstolene sammen, og efterlad dem som ved ankomst.",
          "Tøm køleskabet for jeres egne varer.",
          "Sluk projektor, lys og udstyr, der ikke skal være tændt."
        ]
      }
    },
    "welcome": {
      "title": "Velkomst – Fyrrehaven 61",
      "hero": {
        "title": "Velkommen til Fyrrehaven 61!",
        "subtitle": "Vi glæder os til at byde jer velkommen i smukke og afslappende omgivelser – her kommer lidt praktisk info!"
      },
      "description": "Velkommen til jeres ophold i Fyrrehaven 61. Her finder I praktiske informationer om huset, pool, sauna, og meget mere.",
      "imageAlt": "Velkomst billede",
      "intro": "Her kommer en guide til jeres ophold hos os. Den kan forhåbentlig hjælpe med at gøre jeres oplevelse helt som den skal være. Finder du ikke dine svar her eller andre steder på hjemmesiden, så hører vi selvfølgelig meget gerne fra jer.",
      "manualCta": "Manualen",
      "practicalInfoCta": "Praktisk information",
      "arrival": "Når I ankommer til adressen Fyrrehaven 61, 8585 Glesborg, er der plads til 6 biler i indkørslen. I finder også en el-oplader, skulle denne mod forventning være slukket kan I tjekke hjemmesiden for hvordan I tænder.",
      "meterIntro": "I skal som det første tage ét billede af eltavlen og vandmålerne ved ankomst – og igen ved afrejse – og sende til os for at afregne forbrug.",
      "electricityMeter": "Elmåleren findes til højre for hoveddøren i den overdækkede terrasse.",
      "waterMeters": "Vandmålerne: En findes i teknikskabet i entréen (bruges hele året), og en anden ved poolteknikken i aktivitetsrummet (bruges kun i poolsæson).",
      "keyBox": "Nøgleboksen finder I til højre for hoveddøren. Koden sendes 1 time før ankomst via mail eller Airbnb-besked.",
      "guideIntro": "Vigtigt! Før I bruger pool, sauna og vildmarksbad, skal I læse vejledningen:",
      "pool": "Pool",
      "sauna": "Sauna",
      "hotTub": "Vildmarksbad",
      "hotTubNote": "Husk: I skal ikke bruge brønde til vildmarksbadet, da det varmes elektrisk.",
      "smoking": "Der er rygning forbudt i huset. Hvis du ryger udendørs, så husk at samle skodder op.",
      "pets": "Ingen kæledyr er tilladt. Pas godt på vores ting og giv os besked, hvis noget går i stykker.",
      "departureIntro": "Inden afrejse skal I følge tjeklisten på hjemmesiden:",
      "departureCta": "Tjekliste for afrejse",
      "hope": "Vi håber I får en helt unik og vidunderlig oplevelse!",
      "share": "Del gerne jeres oplevelse med #fyrrehaven61 på sociale medier.",
      "addressTitle": "Find adressen her:",
      "mapAlt": "Kort til sommerhuset",
      "googleMaps": "Google Kort",
      "appleMaps": "Apple Kort"
    }
  },
  "navigation": {
    "public": {
      "house": "Huset",
      "area": "Området",
      "gallery": "Galleri",
      "contact": "Kontakt"
    },
    "guest": {
      "welcome": "Velkomst",
      "manual": "Manual",
      "activityRoom": "Aktivitetsrum",
      "pool": "Pool",
      "sauna": "Sauna",
      "spa": "Vildmarksbad",
      "practicalInfo": "Praktisk info"
    },
    "actions": {
      "book": "Book",
      "bookNow": "Book nu",
      "changeAppearance": "Skift udseende",
      "toggleAppearance": "Skift mellem lys og mørk tilstand",
      "changeLanguage": "Skift sprog",
      "closeMenu": "Luk menu",
      "openMenu": "Åbn menu",
      "currentLanguage": "Aktuelt sprog",
      "currentAppearance": "Aktuelt udseende"
    },
    "appearance": {
      "system": "System",
      "light": "Lys",
      "dark": "Mørk"
    },
    "menu": {
      "main": "Hovednavigation",
      "mobile": "Mobilmenu",
      "title": "Menu",
      "description": "Hovednavigation for siden"
    }
  },
  "footer": {
    "tagline": "Sommerhus ved skov og strand",
    "superhostAria": "Se vores Airbnb-profil (Superhost)",
    "sections": {
      "explore": "Udforsk",
      "contactBooking": "Kontakt & booking",
      "practical": "Praktisk"
    },
    "links": {
      "house": "Sommerhuset",
      "area": "Området",
      "gallery": "Galleri",
      "bookAirbnb": "Book via Airbnb",
      "contact": "Kontakt os",
      "houseRules": "Husregler",
      "faq": "Ofte stillede spørgsmål",
      "activityRoom": "Aktivitetsrum",
      "extraServices": "Ekstra services",
      "privacy": "Privatliv",
      "cookies": "Cookieindstillinger",
      "fees": "Gebyr"
    },
    "socialAria": "Sociale medier",
    "messengerAria": "Skriv til os på Messenger",
    "messengerDismissAria": "Skjul Messenger-knap",
    "guestPageAria": "Gæsteside",
    "rights": "Alle rettigheder forbeholdes."
  },
  "seo": {
    "home": {
      "title": "Sommerhus i Fjellerup | Fyrrehaven 61",
      "description": "Familievenligt sommerhus på Djursland med opvarmet pool (1. maj–1. oktober), vildmarksbad, sauna og aktivitetsrum. Plads til 10 nær Fjellerup Strand.",
      "keywords": [
        "feriehus danmark",
        "sommerhus fjellerup",
        "familieferie danmark",
        "feriehus for norske familier",
        "feriehus for tyske gæster",
        "opvarmet pool sommerhus",
        "vildmarksbad sommerhus",
        "sauna sommerhus",
        "sommerhus med aktivitetsrum",
        "sommerhus med billard",
        "djursland feriehus",
        "Fyrrehaven 61"
      ],
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "Fyrrehaven 61 sommerhus ved Fjellerup Strand",
      "robots": {
        "index": true,
        "follow": true,
        "noarchive": true
      }
    },
    "house": {
      "title": "Sommerhuset | Fyrrehaven 61",
      "description": "Sommerhus til 10 på Djursland med udendørs opvarmet pool (1. maj–1. oktober), elektrisk vildmarksbad, el-sauna og aktivitetsrum med billard, bordtennis, airhockey, dart og projektor. Familievenligt feriehus tæt på skov, strand og lokale attraktioner.",
      "keywords": [
        "sommerhus fjellerup",
        "sommerhus med pool",
        "opvarmet udendørs pool",
        "vildmarksbad",
        "sauna",
        "aktivitetsrum",
        "billard",
        "airhockey",
        "familievenligt sommerhus",
        "10 personer",
        "djursland feriehus",
        "Fyrrehaven 61",
        "tæt på strand og skov"
      ],
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/IMG_3724.jpg",
      "imageAlt": "Udendørs poolområde ved sommerhuset",
      "robots": {
        "index": true,
        "follow": true,
        "noarchive": true
      }
    },
    "area": {
      "title": "Området | Fyrrehaven 61",
      "description": "Oplev Fjellerup og Djursland fra Fyrrehaven 61: skovstier fra døren, strand i gå- og cykelafstand, og familievenlige attraktioner som Djurs Sommerland, Mols Bjerge og Kattegatcentret. Se kortet og vores bedste lokale tips.",
      "keywords": [
        "Fjellerup",
        "Djursland",
        "skov og strand",
        "familievenlige oplevelser",
        "Djurs Sommerland",
        "Mols Bjerge",
        "Kattegatcentret",
        "Grenaa",
        "Ebeltoft",
        "vandreruter",
        "cykelruter",
        "Fyrrehaven 61"
      ],
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "Skov og strand ved Fjellerup",
      "robots": {
        "index": true,
        "follow": true,
        "noarchive": true
      }
    },
    "gallery": {
      "title": "Galleri | Fyrrehaven 61",
      "description": "Se billeder af stue, køkken-alrum, soveværelser, hems og aktivitetsrum – plus udendørs opvarmet pool (1. maj–1. oktober), elektrisk vildmarksbad, el-sauna og nærliggende skov og strand ved Fjellerup. Få et ærligt indtryk.",
      "keywords": [
        "Fyrrehaven 61",
        "galleri",
        "billeder sommerhus",
        "udendørs opvarmet pool",
        "vildmarksbad",
        "sauna",
        "aktivitetsrum",
        "Fjellerup",
        "Djursland",
        "skov og strand",
        "familieferie"
      ],
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "Udklip fra galleriet",
      "robots": {
        "index": true,
        "follow": true,
        "noarchive": true
      }
    },
    "faq": {
      "title": "FAQ | Fyrrehaven 61",
      "description": "Find svar på tjek-ind, pool & wellness, sengetøj, betaling, regler m.m.",
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "FAQ om Fyrrehaven 61",
      "robots": {
        "index": true,
        "follow": true,
        "noarchive": true
      }
    },
    "contact": {
      "title": "Kontakt | Fyrrehaven 61",
      "description": "Har du spørgsmål til datoer, priser, faciliteter eller særlige ønsker? Send os en besked via formularen — vi svarer typisk samme dag. Al kommunikation foregår via e-mail, og dine oplysninger behandles efter vores privatlivspolitik.",
      "keywords": [
        "kontakt",
        "Fyrrehaven 61",
        "sommerhus Fjellerup",
        "spørgsmål booking",
        "udlejning sommerhus",
        "familievenligt sommerhus",
        "pool vildmarksbad sauna",
        "Djursland ferie",
        "book direkte",
        "Airbnb kontakt"
      ],
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "Familien bag huset",
      "robots": {
        "index": true,
        "follow": true,
        "noarchive": true
      }
    },
    "book": {
      "title": "Booking | Fyrrehaven 61",
      "description": "Book direkte hos værterne eller via Airbnb. Udendørs opvarmet pool (1. maj–1. okt.), aktivitetsrum, plads til 10 og familievenligt nær skov og strand. Vi svarer typisk inden for 1 time. El 4 kr./kWh og vand 80 kr./m³ afregnes efter opholdet.",
      "keywords": [
        "booking sommerhus",
        "Fyrrehaven 61 booking",
        "sommerhus Fjellerup",
        "udendørs opvarmet pool",
        "vildmarksbad",
        "sauna",
        "aktivitetsrum",
        "familievenligt sommerhus",
        "book direkte",
        "Airbnb Fjellerup",
        "Djursland feriehus"
      ],
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "Booking af feriehus ved Fjellerup",
      "robots": {
        "index": true,
        "follow": true,
        "noarchive": true
      }
    },
    "cookies": {
      "title": "Cookies | Fyrrehaven 61",
      "description": "Læs om vores brug af cookies og administrer dine valg.",
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "Cookies"
    },
    "fees": {
      "title": "Gebyrer | Fyrrehaven 61",
      "description": "Se vores opdaterede gebyroversigt for Fyrrehaven 61: regler for booking, rengøring, sen check-out og særlige situationer. El (4 kr./kWh) og vand (80 kr./m³) afregnes efter forbrug. Ingen fester/kæledyr. Pool åben 1/5–1/10.",
      "keywords": [
        "gebyrer sommerhus",
        "gebyroversigt",
        "rengøringsgebyr",
        "elforbrug pris",
        "vandforbrug pris",
        "sen check-out gebyr",
        "skader og erstatning",
        "Fyrrehaven 61 priser"
      ],
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "Gebyroversigt",
      "robots": {
        "index": true,
        "follow": true,
        "noarchive": true
      }
    },
    "extraServices": {
      "title": "Ekstra services | Fyrrehaven 61",
      "description": "Se tilkøb til opholdet i Fyrrehaven 61: sengetøj, sengelinned, håndklæder, pakker, påfyldning af vildmarksbad, højstol og babyseng.",
      "keywords": [
        "ekstra services",
        "tilkøb sommerhus",
        "sengetøj sommerhus",
        "håndklæder sommerhus",
        "vildmarksbad påfyldning",
        "babyseng",
        "højstol",
        "Fyrrehaven 61"
      ],
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "Ekstra services til opholdet",
      "robots": {
        "index": true,
        "follow": true,
        "noarchive": true
      }
    },
    "privacy": {
      "title": "Privatliv | Fyrrehaven 61",
      "description": "Læs hvordan vi behandler personoplysninger ved kontakt og booking af Fyrrehaven 61. Vi lagrer henvendelser som e-mail hos Simply, sætter kun nødvendige cookies som udgangspunkt og respekterer dine GDPR-rettigheder.",
      "keywords": [
        "privatlivspolitik",
        "GDPR",
        "persondata",
        "databehandling",
        "dataansvarlig",
        "databehandler",
        "GDPR rettigheder",
        "cookiepolitik",
        "booking personoplysninger",
        "Fyrrehaven 61 privatliv",
        "e-mail opbevaring",
        "Simply e-mailudbyder"
      ],
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "Privatlivspolitik",
      "robots": {
        "index": false,
        "follow": true,
        "noarchive": true
      }
    }
  },
  "house": {
    "jsonLd": {
      "outdoorPool": "Udendørs opvarmet pool",
      "poolSeason": "Åben 1. maj – 1. oktober",
      "hotTub": "Elektrisk vildmarksbad",
      "sauna": "El-sauna",
      "activityRoom": "Aktivitetsrum med spil og projektor",
      "beachForest": "Tæt på strand & skov"
    },
    "hero": {
      "title": "Sommerhuset – plads til 10, pool, wellness & aktivitetsrum",
      "subtitle": "4 soveværelser + hems. Udendørs opvarmet pool (1. maj–1. oktober), elektrisk vildmarksbad, el-sauna og aktivitetsrum.",
      "badges": [
        "10 gæster",
        "4 soveværelser",
        "2 badeværelser",
        "Udendørs opvarmet pool",
        "Vildmarksbad",
        "Sauna",
        "Aktivitetsrum"
      ],
      "primaryCta": "Book privat",
      "secondaryCta": "Book | Airbnb",
      "imageAlt": "Udendørs poolområde ved sommerhuset",
      "imageTitle": "Fyrrehaven 61 – feriehus ved Fjellerup Strand"
    },
    "sleeping": {
      "title": "Sovepladser & planløsning",
      "bedsTitle": "Senge (dobbeltsenge)",
      "beds": [
        "4 dobbeltsenge i alt: 2× 180×200 cm og 2× 200×200 cm",
        "Hver dobbeltseng har 2 puder (fiber 60×63/70) og 2 fiberdyner 135×200"
      ],
      "storageTitle": "Sengetøj & opbevaring",
      "storage": [
        "Sengetøj kan lejes efter ønske – ellers medbringes",
        "Kommode med skuffer til tøj",
        "Spejl",
        "Hængekrog bag døren",
        "2 natlamper"
      ]
    },
    "wellness": {
      "title": "Pool & wellness",
      "poolTitle": "Udendørs pool",
      "pool": [
        "1,5 m dyb",
        "3,5 m bred · 8 m lang",
        "Opvarmet ca. 29 °C",
        "Sæson: 1. maj – 1. oktober",
        "Tag/overdækning kan lukkes på kolde eller vindfulde dage",
        "Lys i poolen (kan tændes)",
        "Automatisk tilførsel af poolkemi"
      ],
      "hotTubTitle": "EL-Vildmarksbad",
      "hotTub": [
        "Op til 6 personer",
        "Opvarmes med EL",
        "Massagefunktion og lys",
        "Vand fyldes med haveslange – kan mod tilkøb være fyldt før ankomst"
      ],
      "saunaTitle": "Sauna",
      "sauna": [
        "Op til 8 personer",
        "Lys indvendig og udvendig",
        "Hæld stille og roligt vand på ovnen for damp"
      ]
    },
    "activityRoom": {
      "title": "Aktivitetsrum",
      "gamesTitle": "Spil i rummet",
      "games": [
        "3-i-1 bord til billard, bordtennis og airhockey",
        "Dartskive over køleskabet med sikkerhedspuder omkring",
        "Airhockey bruger strøm og skal tilsluttes stikkontakt før brug"
      ],
      "movieTitle": "Film & ophold",
      "movie": [
        "Projektor med Chromecast og Google TV",
        "Bluetooth soundbar til filmlyd",
        "Folde stole og ekstra plads til hyggelige aftener"
      ]
    },
    "kitchenLiving": {
      "title": "Køkken & ophold",
      "kitchenTitle": "Køkken",
      "kitchen": [
        "Fuldudstyret køkken: køle-/fryseskab, ovn, mikroovn",
        "Automatisk kaffemaskine, filterkaffe og stempelkande",
        "Affaldssortering"
      ],
      "livingTitle": "Ophold & underholdning",
      "living": [
        "Stort spisebord med plads til 10 personer",
        "Lyst rum med vinduer fra begge sider",
        "TV-område med sofa, stole og 55″ TV",
        "Udendørs rutsjebane",
        "Trampolin",
        "PlayStation 4"
      ]
    }
  },
  "facilities": {
    "aria": "Faciliteter",
    "title": "Faciliteter – komplet liste",
    "intro": "El- og vandforbrug afregnes efter endt ophold og betales via bankoverførsel.",
    "categories": {
      "kitchen": {
        "title": "Køkken",
        "bullets": [
          "Fuldt udstyret køkken",
          "Køle-/fryseskab, ovn og mikroovn",
          "Automatisk kaffemaskine, filter- og stempelkaffe",
          "Sodastream inkl. udskiftelig patron",
          "Service til 10: tallerkner, bestik, glas, kopper, champagne- og vinglas",
          "Vandkander og isbakke",
          "Affaldssortering",
          "Gasgrill"
        ]
      },
      "living": {
        "title": "Ophold & praktisk",
        "bullets": [
          "Stort spisebord til 10",
          "TV 55\" og PlayStation 4 i stuen",
          "Gulvvarme i hele huset · Aircondition",
          "Vaskemaskine og tørretumbler",
          "Rejseseng til børn (bestilles gratis forud)",
          "Strygejern og hårtørrer",
          "El-lader til elbil"
        ]
      },
      "activityRoom": {
        "title": "Aktivitetsrum",
        "bullets": [
          "3-i-1 bord til billard, bordtennis og airhockey",
          "Dartskive over køleskabet med sikkerhedspuder omkring",
          "Projektor med Chromecast, Google TV og Bluetooth soundbar",
          "Folde stole og lille køleskab i rummet"
        ]
      },
      "outdoor": {
        "title": "Udendørs",
        "bullets": [
          "Udendørs pool opvarmet ~29°C (1. maj – 1. oktober) med overdækning",
          "Elektrisk vildmarksbad (op til 6 pers.) med lys og massage",
          "El-sauna (op til ca. 8 pers.) – mulighed for lidt vand på stenene",
          "Trampolin samt gynge/legetårn med rutschebane"
        ]
      },
      "checkin": {
        "title": "Indtjekning",
        "bullets": [
          "Selv-indtjekning via nøgleboks (kode sendes 1 time før ankomst)",
          "Ind kl. 16:00 · Ud kl. 10:00",
          "Upload fotos af el- og vandmåler via hjemmesiden ved ind-/udtjekning"
        ]
      },
      "rules": {
        "title": "Husregler",
        "bullets": [
          "Ingen fester",
          "Røgfrit hus (ingen rygning indendørs)",
          "Adgang forbudt i anneks og skur",
          "Ophold forbudt i pool-teknikrum"
        ]
      }
    }
  },
  "cookiesPage": {
    "consent": {
      "brandName": "Fyrrehaven 61",
      "title": "Vi bruger cookies",
      "description": "Vi bruger nødvendige cookies for at få siden til at fungere og huske dine cookieindstillinger.",
      "acceptAll": "OK",
      "rejectAll": "Afvis",
      "preferences": "Indstil cookies",
      "settingsTitle": "Cookieindstillinger",
      "close": "Luk",
      "save": "Gem præferencer",
      "manageButton": "Administrer cookieindstillinger",
      "footer": "Du kan til enhver tid ændre eller trække dit samtykke tilbage via cookieindstillingerne."
    },
    "categories": {
      "necessary": {
        "title": "Nødvendige cookies",
        "label": "Nødvendige",
        "description": "Påkrævet for at siden fungerer. Disse cookies kan ikke fravælges.",
        "tableCaption": "Nødvendige cookies"
      },
      "statistics": {
        "title": "Statistikcookies",
        "label": "Statistik",
        "description": "Valgfri statistik, som hjælper os med at forstå hvordan siden bruges. De indlæses kun hvis du tillader dem.",
        "tableCaption": "Statistikcookies"
      }
    },
    "preferences": {
      "introTitle": "Cookieindstillinger",
      "introDescription": "Nødvendige cookies er altid aktive, fordi hjemmesiden skal bruge dem for at fungere. Hvis vi aktiverer statistik, kører den kun efter dit samtykke."
    },
    "table": {
      "name": "Navn",
      "provider": "Udbyder",
      "purpose": "Formål",
      "expiration": "Udløb",
      "type": "Type"
    },
    "page": {
      "title": "Cookies hos Fyrrehaven 61",
      "intro": "Her kan du læse om vores brug af cookies og hvordan du ændrer dine præferencer.",
      "typesTitle": "Typer af cookies"
    }
  },
  "privacyPage": {
    "title": "Privatlivspolitik",
    "lead": "Denne politik beskriver, hvordan vi som dataansvarlig behandler personoplysninger efter GDPR og dansk ret.",
    "controller": {
      "title": "Dataansvarlig",
      "address": "Fyrrehaven 61, 8585 Glesborg, Danmark",
      "emailLabel": "E-mail",
      "phoneLabel": "Telefon",
      "dpo": "Vi har ikke udpeget en databeskyttelsesrådgiver (DPO). Kontakt os på e-mailadressen ovenfor ved spørgsmål."
    },
    "sections": {
      "scope": {
        "title": "Anvendelsesområde og datakilder",
        "body": "Politikken dækker vores hjemmeside, kontakt/booking via formularer og bestilling af ekstra services. Oplysninger stammer primært fra dig (formularer/kommunikation), fra din enhed (tekniske logs) og i nogle tilfælde fra tredjepartsplatforme (fx Airbnb)."
      },
      "categories": {
        "title": "Kategorier af personoplysninger",
        "items": [
          {
            "label": "Kontaktoplysninger",
            "text": "Navn, e-mail, telefon, land."
          },
          {
            "label": "Bookingdata",
            "text": "Ankomst/afrejse, nætter, antal gæster (voksne/børn/babyer), formål med opholdet, accepterede gebyrer/priser."
          },
          {
            "label": "Ekstra services",
            "text": "Valgte ydelser og mængder (sengetøj, sengelinned, håndklæder, pakker m.v.)."
          },
          {
            "label": "Kommunikation",
            "text": "Korrespondance med dig (fx e-mails)."
          },
          {
            "label": "Tekniske data",
            "text": "IP-adresse, tidsstempler, URL’er, enheds-/browseroplysninger og lignende basale logdata af sikkerhedsmæssige grunde."
          },
          {
            "label": "Særlige kategorier",
            "text": "Vi behandler ikke følsomme oplysninger (art. 9)."
          }
        ]
      },
      "purposes": {
        "title": "Formål og retsgrundlag",
        "items": [
          {
            "label": "Forespørgsler og booking",
            "text": "Besvare henvendelser, forberede/indgå lejeaftale og levere ydelser (art. 6(1)(b))."
          },
          {
            "label": "Regnskab og pligter",
            "text": "Overholdelse af lovkrav (art. 6(1)(c))."
          },
          {
            "label": "Sikkerhed og drift",
            "text": "IT-sikkerhed, misbrugsforebyggelse, fejlsøgning (legitim interesse; art. 6(1)(f))."
          },
          {
            "label": "Markedsføring",
            "text": "Kun med samtykke (art. 6(1)(a))."
          }
        ]
      },
      "necessity": {
        "title": "Er oplysningerne nødvendige?",
        "body": "Når vi beder om oplysninger, er det for at kunne besvare din henvendelse eller indgå/administrere en booking. Uden oplysningerne kan vi muligvis ikke levere den ønskede service."
      },
      "recipients": {
        "title": "Modtagere og internationale overførsler",
        "body": "Vi anvender betroede databehandlere til drift og kommunikation (fx hosting, e-mail og sikkerhed). De behandler kun data efter instruks og under passende databehandleraftaler. Ved eventuelle overførsler uden for EU/EØS anvendes gyldige overførselsgrundlag (typisk EU’s standardkontraktbestemmelser, SCC).",
        "items": [
          {
            "label": "E-mail",
            "text": "Formularindsendelser leveres som e-mails til vores postkasse hos Simply (e-mailudbyder)."
          },
          {
            "label": "Tredjepartsplatforme",
            "text": "Når du bruger links til fx Airbnb eller sociale medier, er disse selvstændigt dataansvarlige for deres behandling."
          }
        ]
      },
      "storage": {
        "title": "Opbevaring og adgang til oplysninger",
        "paragraphs": [
          "Vi opbevarer ikke dine oplysninger i en separat database. Alle oplysninger, du indsender via vores formularer, sendes og lagres som e-mail i vores postkasse hos Simply. Vi tilgår kun personoplysninger via vores e-mailklient/webmail hos Simply.",
          "Transporten af e-mails sker som udgangspunkt via TLS, når modtagende server understøtter det."
        ]
      },
      "retention": {
        "title": "Opbevaringsperioder",
        "items": [
          "Henvendelser (i indbakken): normalt op til 12 måneder, medmindre korrespondancen indgår i en booking eller et retskrav.",
          "Booking- og regnskabsdata i e-mail/vedhæftninger: som udgangspunkt 5 år af hensyn til bogføringsregler.",
          "Sikkerheds-/adgangslogs: typisk 6 måneder."
        ]
      },
      "cookies": {
        "title": "Cookies og lignende teknologier",
        "body": "Vi bruger teknisk nødvendige cookies/lagring for at levere siden sikkert og huske dine cookieindstillinger. Valgfri statistik kører kun hvis du aktivt tillader statistikcookies."
      },
      "rights": {
        "title": "Dine rettigheder",
        "items": [
          "Indsigt (art. 15)",
          "Berigtigelse (art. 16)",
          "Sletning (art. 17)",
          "Begrænsning (art. 18)",
          "Dataportabilitet (art. 20)",
          "Indsigelse (art. 21)",
          "Tilbagekald samtykke (art. 7(3)) — påvirker ikke lovligheden før tilbagekaldelsen."
        ],
        "paragraphs": [
          "Skriv til os på ovenstående e-mail for at udøve dine rettigheder. Vi svarer som udgangspunkt inden 1 måned og kan bede om identifikation.",
          "Du kan klage til Datatilsynet: www.datatilsynet.dk."
        ]
      },
      "automated": {
        "title": "Automatiske afgørelser",
        "body": "Vi foretager ikke automatiske afgørelser eller profilering med retsvirkning eller tilsvarende betydelig påvirkning (art. 22)."
      },
      "changes": {
        "title": "Ændringer af denne politik",
        "body": "Vi opdaterer denne politik ved ændringer i behandlingen eller når lovgivningen kræver det. Væsentlige ændringer offentliggøres her.",
        "updatedLabel": "Senest opdateret",
        "updated": "16. september 2025"
      },
      "contact": {
        "title": "Kontakt",
        "body": "Har du spørgsmål til denne privatlivspolitik, er du velkommen til at kontakte os."
      }
    }
  }
} as const;
